import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip, Avatar, Typography, Box } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const getStatusColor = (status) => {
    switch (status) {
        case 'pending':
            return 'warning';
        case 'in_progress':
            return 'info';
        case 'completed':
            return 'success';
        case 'cancelled':
            return 'error';
        default:
            return 'default';
    }
};

const getStatusLabel = (status, isArabic) => {
    const labels = {
        pending: { en: 'Pending', ar: 'معلق' },
        in_progress: { en: 'In Progress', ar: 'قيد التنفيذ' },
        completed: { en: 'Completed', ar: 'مكتمل' },
        cancelled: { en: 'Cancelled', ar: 'ملغي' },
    };
    return labels[status]?.[isArabic ? 'ar' : 'en'] || status;
};

const ProjectsTableRow = ({
    project,
    index,
    perms,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
    isArabic,
}) => {
    const isSelected = selectedIds.includes(project.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, project.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            {/* العنوان مع الصورة */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {project.images && project.images.length > 0 && (
                        <Avatar
                            src={project.images[0]}
                            alt={isArabic ? (project.title?.ar || project.title) : (project.title?.en || project.title)}
                            sx={{ width: 40, height: 40 }}
                            variant="rounded"
                        />
                    )}
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {isArabic
                                ? (project?.title?.ar || project?.title?.en || (typeof project?.title === 'string' ? project.title : '-'))
                                : (project?.title?.en || project?.title?.ar || (typeof project?.title === 'string' ? project.title : '-'))
                            }
                        </Typography>
                    </Box>
                </Box>
            </TableCell>

            {/* Slug */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {project?.slug
                    ? <Chip label={project.slug} size="small" variant="outlined" sx={{ borderRadius: '6px', fontWeight: 'bold', fontFamily: 'monospace' }} />
                    : '-'
                }
            </TableCell>

            {/* العميل */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {project?.client
                    ? (isArabic
                        ? (project.client.name?.ar || project.client.name?.en || (typeof project.client.name === 'string' ? project.client.name : '-'))
                        : (project.client.name?.en || project.client.name?.ar || (typeof project.client.name === 'string' ? project.client.name : '-')))
                    : '-'
                }
            </TableCell>

            {/* الفئة */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {project?.category
                    ? (isArabic
                        ? (project.category.name?.ar || project.category.name?.en || (typeof project.category.name === 'string' ? project.category.name : '-'))
                        : (project.category.name?.en || project.category.name?.ar || (typeof project.category.name === 'string' ? project.category.name : '-')))
                    : '-'
                }
            </TableCell>

            {/* الحالة */}
            <TableCell align="center">
                <Chip
                    label={getStatusLabel(project?.status, isArabic)}
                    size="small"
                    color={getStatusColor(project?.status)}
                    variant="outlined"
                    sx={{ borderRadius: '6px' }}
                />
            </TableCell>

            {/* مميز */}
            <TableCell align="center">
                <Chip
                    label={project?.is_featured ? (isArabic ? 'نعم' : 'Yes') : (isArabic ? 'لا' : 'No')}
                    size="small"
                    color={project?.is_featured ? 'primary' : 'default'}
                    variant="outlined"
                    sx={{ borderRadius: '6px' }}
                />
            </TableCell>

            {/* تاريخ الإضافة */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {project?.created_at ? dayjs(project.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* الإجراءات */}
            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, project)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default ProjectsTableRow;